import { createContext } from "react";
import { AppColorsContextType } from "@/types/contextTypes";

export const AppColorsContext = createContext<AppColorsContextType | undefined>(
  undefined,
);
